// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Customer portal (/client/*, /portal/activate). Mobile first; everything scoped to .portal-page. */

.portal-page {
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
}

.portal-page .portal-gap {
  margin-bottom: var(--ds-space-4);
}

.portal-page .portal-gap-top {
  margin-top: var(--ds-space-4);
}

.portal-page .portal-card {
  border-radius: var(--ds-radius-lg);
}

.portal-page .portal-card .ant-card-body {
  overflow-wrap: anywhere;
}

/* ---- Overview ---- */
.portal-page .portal-hero {
  display: flex;
  align-items: center;
  gap: var(--ds-space-4);
  padding: var(--ds-space-5);
  margin-bottom: var(--ds-space-4);
  border-radius: var(--ds-radius-xl);
  background: var(--ds-chrome-gradient, var(--ds-chrome-bg));
  color: var(--ds-chrome-text-strong);
}

.portal-page .portal-hero h2 {
  margin: 0;
  font-family: var(--ds-font-display);
  font-size: 1.35rem;
  color: inherit;
}

.portal-page .portal-hero p {
  margin: var(--ds-space-1) 0 0;
  color: var(--ds-chrome-text);
}

.portal-page .portal-hero__logo {
  max-height: 48px;
  max-width: 120px;
  padding: var(--ds-space-1);
  border-radius: var(--ds-radius-sm);
  background: var(--ds-surface);
}

.portal-page .portal-row {
  display: flex;
  align-items: center;
  gap: var(--ds-space-3);
  width: 100%;
  min-height: var(--ds-touch, 44px);
  color: inherit;
}

.portal-page .portal-row__icon {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: var(--ds-radius-md);
  background: var(--ds-brand-50);
  color: var(--ds-brand);
}

.portal-page .portal-row__main {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.portal-page .portal-row__end {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  flex: none;
  font-variant-numeric: tabular-nums;
}

.portal-page .portal-chevron {
  font-size: 12px;
  color: var(--ds-text-muted);
}

[dir="rtl"] .portal-page .portal-chevron {
  transform: scaleX(-1);
}

.portal-page .portal-total {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  padding: var(--ds-space-3);
  margin-bottom: var(--ds-space-2);
  border-radius: var(--ds-radius-md);
  background: var(--ds-surface-muted);
}

.portal-page .portal-total strong {
  margin-inline-start: auto;
  font-size: 1.2rem;
  font-variant-numeric: tabular-nums;
}

.portal-page .portal-appointment {
  width: 100%;
}

.portal-page .portal-slots {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--ds-space-2);
  margin-top: var(--ds-space-2);
}

.portal-page .portal-project {
  width: 100%;
}

.portal-page .portal-project__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ds-space-2);
}

/* ---- Offer / invoice detail ---- */
.portal-page .portal-back {
  display: inline-flex;
  align-items: center;
  gap: var(--ds-space-2);
  min-height: 40px;
  margin-bottom: var(--ds-space-2);
}

.portal-page .portal-doc-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--ds-space-3);
}

.portal-page .portal-doc-head h4 {
  margin: 0;
}

.portal-page .portal-text {
  margin-top: var(--ds-space-4);
  white-space: pre-line;
}

.portal-page .portal-positions {
  margin: var(--ds-space-4) 0 0;
  padding: 0;
  list-style: none;
  border-top: 1px solid var(--ds-border-soft);
}

.portal-page .portal-positions li {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-1);
  padding: var(--ds-space-3) 0;
  border-bottom: 1px solid var(--ds-border-soft);
}

.portal-page .portal-positions__head {
  display: flex;
  justify-content: space-between;
  gap: var(--ds-space-3);
}

.portal-page .portal-positions__text {
  min-width: 0;
}

.portal-page .portal-positions__long {
  white-space: pre-line;
  color: var(--ds-text-2);
}

.portal-page .portal-positions__optional {
  opacity: 0.7;
}

.portal-page .portal-num {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.portal-page .portal-totals {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: var(--ds-space-1) var(--ds-space-4);
  margin: var(--ds-space-4) 0 0;
  margin-inline-start: auto;
  max-width: 360px;
  font-variant-numeric: tabular-nums;
}

.portal-page .portal-totals dd {
  margin: 0;
  text-align: end;
}

.portal-page .portal-totals__gross {
  font-weight: 700;
  font-size: 1.1rem;
  padding-top: var(--ds-space-2);
  border-top: 1px solid var(--ds-border);
}

.portal-page .portal-signature {
  display: block;
  max-width: 100%;
  max-height: 120px;
  margin: var(--ds-space-2) 0;
  padding: var(--ds-space-2);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-md);
  background: var(--ds-surface);
}

.portal-page .portal-hash {
  display: block;
  font-size: 12px;
  overflow-wrap: anywhere;
}

/* ---- Payment ---- */
.portal-page .portal-pay {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-4);
}

.portal-page .portal-girocode {
  margin: 0;
  text-align: center;
}

.portal-page .portal-girocode img {
  width: 100%;
  max-width: 200px;
  background: var(--ds-surface);
}

.portal-page .portal-girocode figcaption {
  font-size: 13px;
  color: var(--ds-text-muted);
}

.portal-page .portal-transfer {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: var(--ds-space-2) var(--ds-space-4);
  margin: 0;
}

.portal-page .portal-transfer dt {
  color: var(--ds-text-muted);
}

.portal-page .portal-transfer dd {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ds-space-1);
  margin: 0;
  min-width: 0;
}

.portal-page .portal-select {
  width: 100%;
  min-width: 160px;
  max-width: 260px;
}

/* ---- Messages ---- */
.portal-page .portal-messages__layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--ds-space-4);
}

.portal-page .portal-thread {
  cursor: pointer;
  border-radius: var(--ds-radius-md);
  padding-inline: var(--ds-space-2) !important;
}

.portal-page .portal-thread.is-active {
  background: var(--ds-brand-50);
}

.portal-page .portal-thread__button {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;
  min-height: 44px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: start;
  cursor: pointer;
  min-width: 0;
}

.portal-page .portal-thread__button .ant-typography {
  max-width: 100%;
}

.portal-page .portal-thread__title {
  display: inline-flex;
  align-items: center;
  gap: var(--ds-space-2);
}

.portal-page .portal-bubbles {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-3);
  max-height: 60vh;
  overflow-y: auto;
  padding-bottom: var(--ds-space-2);
}

.portal-page .portal-bubble {
  align-self: flex-start;
  max-width: 85%;
  padding: var(--ds-space-2) var(--ds-space-3);
  border-radius: var(--ds-radius-lg);
  background: var(--ds-surface-muted);
}

.portal-page .portal-bubble.is-mine {
  align-self: flex-end;
  background: var(--ds-brand-50);
}

.portal-page .portal-bubble__text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.portal-page .portal-bubble__author,
.portal-page .portal-bubble__time {
  display: block;
  font-size: 12px;
}

.portal-page .portal-compose {
  display: flex;
  align-items: flex-end;
  gap: var(--ds-space-2);
  margin-top: var(--ds-space-3);
}

/* ---- Consent ---- */
.portal-page .portal-consent {
  margin: 0 0 var(--ds-space-3);
  padding: 0;
  list-style: none;
}

.portal-page .portal-consent li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ds-space-3);
  min-height: 48px;
  border-bottom: 1px solid var(--ds-border-soft);
}

/* ---- Invitation page (no app shell) ---- */
.portal-page.portal-public {
  min-height: 100vh;
  padding: var(--ds-space-4) 16px;
  background: var(--ds-bg);
}

.portal-page .portal-public__inner {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
}

.portal-page .portal-public__logo {
  display: block;
  max-height: 56px;
  max-width: 180px;
  margin-bottom: var(--ds-space-4);
}

@media (min-width: 768px) {
  .portal-page .portal-slots {
    grid-template-columns: 1fr 1fr;
  }

  .portal-page .portal-pay {
    flex-direction: row;
    align-items: flex-start;
  }

  .portal-page .portal-messages__layout {
    grid-template-columns: minmax(220px, 1fr) 2fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/normalUsers/components/portal/portal.css"],"names":[],"mappings":"AAAA,oGAAoG;;AAEpG;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,gCAAgC;EAChC,kCAAkC;EAClC,0DAA0D;EAC1D,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,gCAAgC;EAChC,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,wCAAwC;EACxC,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,0BAA0B;EAC1B,uCAAuC;EACvC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,4CAA4C;EAC5C,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;EACE,6BAA6B;EAC7B,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA,6CAA6C;AAC7C;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,6CAA6C;EAC/C;AACF","sourcesContent":["/* Customer portal (/client/*, /portal/activate). Mobile first; everything scoped to .portal-page. */\n\n.portal-page {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  min-width: 0;\n}\n\n.portal-page .portal-gap {\n  margin-bottom: var(--ds-space-4);\n}\n\n.portal-page .portal-gap-top {\n  margin-top: var(--ds-space-4);\n}\n\n.portal-page .portal-card {\n  border-radius: var(--ds-radius-lg);\n}\n\n.portal-page .portal-card .ant-card-body {\n  overflow-wrap: anywhere;\n}\n\n/* ---- Overview ---- */\n.portal-page .portal-hero {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-4);\n  padding: var(--ds-space-5);\n  margin-bottom: var(--ds-space-4);\n  border-radius: var(--ds-radius-xl);\n  background: var(--ds-chrome-gradient, var(--ds-chrome-bg));\n  color: var(--ds-chrome-text-strong);\n}\n\n.portal-page .portal-hero h2 {\n  margin: 0;\n  font-family: var(--ds-font-display);\n  font-size: 1.35rem;\n  color: inherit;\n}\n\n.portal-page .portal-hero p {\n  margin: var(--ds-space-1) 0 0;\n  color: var(--ds-chrome-text);\n}\n\n.portal-page .portal-hero__logo {\n  max-height: 48px;\n  max-width: 120px;\n  padding: var(--ds-space-1);\n  border-radius: var(--ds-radius-sm);\n  background: var(--ds-surface);\n}\n\n.portal-page .portal-row {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-3);\n  width: 100%;\n  min-height: var(--ds-touch, 44px);\n  color: inherit;\n}\n\n.portal-page .portal-row__icon {\n  flex: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: var(--ds-radius-md);\n  background: var(--ds-brand-50);\n  color: var(--ds-brand);\n}\n\n.portal-page .portal-row__main {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n}\n\n.portal-page .portal-row__end {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  flex: none;\n  font-variant-numeric: tabular-nums;\n}\n\n.portal-page .portal-chevron {\n  font-size: 12px;\n  color: var(--ds-text-muted);\n}\n\n[dir=\"rtl\"] .portal-page .portal-chevron {\n  transform: scaleX(-1);\n}\n\n.portal-page .portal-total {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  padding: var(--ds-space-3);\n  margin-bottom: var(--ds-space-2);\n  border-radius: var(--ds-radius-md);\n  background: var(--ds-surface-muted);\n}\n\n.portal-page .portal-total strong {\n  margin-inline-start: auto;\n  font-size: 1.2rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.portal-page .portal-appointment {\n  width: 100%;\n}\n\n.portal-page .portal-slots {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--ds-space-2);\n  margin-top: var(--ds-space-2);\n}\n\n.portal-page .portal-project {\n  width: 100%;\n}\n\n.portal-page .portal-project__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--ds-space-2);\n}\n\n/* ---- Offer / invoice detail ---- */\n.portal-page .portal-back {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  min-height: 40px;\n  margin-bottom: var(--ds-space-2);\n}\n\n.portal-page .portal-doc-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--ds-space-3);\n}\n\n.portal-page .portal-doc-head h4 {\n  margin: 0;\n}\n\n.portal-page .portal-text {\n  margin-top: var(--ds-space-4);\n  white-space: pre-line;\n}\n\n.portal-page .portal-positions {\n  margin: var(--ds-space-4) 0 0;\n  padding: 0;\n  list-style: none;\n  border-top: 1px solid var(--ds-border-soft);\n}\n\n.portal-page .portal-positions li {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-1);\n  padding: var(--ds-space-3) 0;\n  border-bottom: 1px solid var(--ds-border-soft);\n}\n\n.portal-page .portal-positions__head {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--ds-space-3);\n}\n\n.portal-page .portal-positions__text {\n  min-width: 0;\n}\n\n.portal-page .portal-positions__long {\n  white-space: pre-line;\n  color: var(--ds-text-2);\n}\n\n.portal-page .portal-positions__optional {\n  opacity: 0.7;\n}\n\n.portal-page .portal-num {\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.portal-page .portal-totals {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: var(--ds-space-1) var(--ds-space-4);\n  margin: var(--ds-space-4) 0 0;\n  margin-inline-start: auto;\n  max-width: 360px;\n  font-variant-numeric: tabular-nums;\n}\n\n.portal-page .portal-totals dd {\n  margin: 0;\n  text-align: end;\n}\n\n.portal-page .portal-totals__gross {\n  font-weight: 700;\n  font-size: 1.1rem;\n  padding-top: var(--ds-space-2);\n  border-top: 1px solid var(--ds-border);\n}\n\n.portal-page .portal-signature {\n  display: block;\n  max-width: 100%;\n  max-height: 120px;\n  margin: var(--ds-space-2) 0;\n  padding: var(--ds-space-2);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-md);\n  background: var(--ds-surface);\n}\n\n.portal-page .portal-hash {\n  display: block;\n  font-size: 12px;\n  overflow-wrap: anywhere;\n}\n\n/* ---- Payment ---- */\n.portal-page .portal-pay {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-4);\n}\n\n.portal-page .portal-girocode {\n  margin: 0;\n  text-align: center;\n}\n\n.portal-page .portal-girocode img {\n  width: 100%;\n  max-width: 200px;\n  background: var(--ds-surface);\n}\n\n.portal-page .portal-girocode figcaption {\n  font-size: 13px;\n  color: var(--ds-text-muted);\n}\n\n.portal-page .portal-transfer {\n  display: grid;\n  grid-template-columns: max-content 1fr;\n  gap: var(--ds-space-2) var(--ds-space-4);\n  margin: 0;\n}\n\n.portal-page .portal-transfer dt {\n  color: var(--ds-text-muted);\n}\n\n.portal-page .portal-transfer dd {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--ds-space-1);\n  margin: 0;\n  min-width: 0;\n}\n\n.portal-page .portal-select {\n  width: 100%;\n  min-width: 160px;\n  max-width: 260px;\n}\n\n/* ---- Messages ---- */\n.portal-page .portal-messages__layout {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--ds-space-4);\n}\n\n.portal-page .portal-thread {\n  cursor: pointer;\n  border-radius: var(--ds-radius-md);\n  padding-inline: var(--ds-space-2) !important;\n}\n\n.portal-page .portal-thread.is-active {\n  background: var(--ds-brand-50);\n}\n\n.portal-page .portal-thread__button {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  width: 100%;\n  min-height: 44px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  text-align: start;\n  cursor: pointer;\n  min-width: 0;\n}\n\n.portal-page .portal-thread__button .ant-typography {\n  max-width: 100%;\n}\n\n.portal-page .portal-thread__title {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n}\n\n.portal-page .portal-bubbles {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-3);\n  max-height: 60vh;\n  overflow-y: auto;\n  padding-bottom: var(--ds-space-2);\n}\n\n.portal-page .portal-bubble {\n  align-self: flex-start;\n  max-width: 85%;\n  padding: var(--ds-space-2) var(--ds-space-3);\n  border-radius: var(--ds-radius-lg);\n  background: var(--ds-surface-muted);\n}\n\n.portal-page .portal-bubble.is-mine {\n  align-self: flex-end;\n  background: var(--ds-brand-50);\n}\n\n.portal-page .portal-bubble__text {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.portal-page .portal-bubble__author,\n.portal-page .portal-bubble__time {\n  display: block;\n  font-size: 12px;\n}\n\n.portal-page .portal-compose {\n  display: flex;\n  align-items: flex-end;\n  gap: var(--ds-space-2);\n  margin-top: var(--ds-space-3);\n}\n\n/* ---- Consent ---- */\n.portal-page .portal-consent {\n  margin: 0 0 var(--ds-space-3);\n  padding: 0;\n  list-style: none;\n}\n\n.portal-page .portal-consent li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--ds-space-3);\n  min-height: 48px;\n  border-bottom: 1px solid var(--ds-border-soft);\n}\n\n/* ---- Invitation page (no app shell) ---- */\n.portal-page.portal-public {\n  min-height: 100vh;\n  padding: var(--ds-space-4) 16px;\n  background: var(--ds-bg);\n}\n\n.portal-page .portal-public__inner {\n  width: 100%;\n  max-width: 480px;\n  margin: 0 auto;\n}\n\n.portal-page .portal-public__logo {\n  display: block;\n  max-height: 56px;\n  max-width: 180px;\n  margin-bottom: var(--ds-space-4);\n}\n\n@media (min-width: 768px) {\n  .portal-page .portal-slots {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .portal-page .portal-pay {\n    flex-direction: row;\n    align-items: flex-start;\n  }\n\n  .portal-page .portal-messages__layout {\n    grid-template-columns: minmax(220px, 1fr) 2fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
